<template>
  <div>
    <!-- 1：个推，2：FCM，3：友盟 -->
    <div>
      <md-button :class="{'md-info': msg_plat_type == 1}" @click="() => { msg_plat_type = 1 }" class="md-simple">{{$I18n("one_push")}}</md-button>
      <md-button :class="{'md-info': msg_plat_type == 2}" @click="() => { msg_plat_type = 2 }" class="md-simple">{{$I18n("fcm")}}</md-button>
      <!-- <md-button :class="{'md-info': msg_plat_type == 3}" @click="() => { msg_plat_type = 3 }" class="md-simple">{{$I18n("umeng")}}</md-button> -->
      <md-button :class="{'md-info': msg_plat_type == 4}" @click="() => { msg_plat_type = 4 }" class="md-simple">{{$I18n("jpush")}}</md-button>
      <md-button v-if="client == 3" :class="{'md-info': msg_plat_type == 5}" @click="() => { msg_plat_type = 5 }" class="md-simple">{{$I18n("xiaomi")}}</md-button>
      <md-button v-if="client == 3" :class="{'md-info': msg_plat_type == 6}" @click="() => { msg_plat_type = 6 }" class="md-simple">{{$I18n("huawei")}}</md-button>
      <md-button v-if="client == 2" :class="{'md-info': msg_plat_type == 7}" @click="() => { msg_plat_type = 7 }" class="md-simple">{{$I18n("apns")}}</md-button>
      <md-button v-if="client == 3" :class="{'md-info': msg_plat_type == 8}" @click="() => { msg_plat_type = 8 }" class="md-simple">{{$I18n("oppo")}}</md-button>
      <md-button v-if="client == 3" :class="{'md-info': msg_plat_type == 9}" @click="() => { msg_plat_type = 9 }" class="md-simple">{{$I18n("vivo")}}</md-button>
      <md-button v-if="client == 3" :class="{'md-info': msg_plat_type ==10}" @click="() => { msg_plat_type =10 }" class="md-simple">{{$I18n("honor")}}</md-button>
    </div>
    <div v-if="msg_plat_type == 1">
      <!-- 平台应用ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"APP ID"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.access_id}">
              <md-input v-model="msg_plat_conf_form.access_id" required />
              <md-icon v-if="error.access_id">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 平台应用 KEY -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"APP Key"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.access_key}">
              <md-input v-model="msg_plat_conf_form.access_key" required />
              <md-icon v-if="error.access_key">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 平台应用Secret KEY -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"Master Secret"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.secret_key}">
              <md-input v-model="msg_plat_conf_form.secret_key" required />
              <md-icon v-if="error.secret_key">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 小米渠道ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("xm_ch_id")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.xm_ch_id" />
            </md-field>
          </div>
        </div>
      </div>
      <!-- OPPO ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("oppo_ch_id")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.oppo_ch_id" />
            </md-field>
          </div>
        </div>
      </div>
      <!-- 本地通知 ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("notif_ch_id")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.notif_ch_id" />
            </md-field>
          </div>
        </div>
      </div>
      <!-- 打开方式 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("open_type")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-select v-model="msg_plat_conf_form.open_type">
                <!-- <md-option :value="0">{{$I18n("none")}}</md-option> -->
                <md-option :value="1">{{$I18n("open_app")}}</md-option>
                <md-option :value="2">{{$I18n("open_activity")}}</md-option>
                <md-option :value="3">{{$I18n("open_url")}}</md-option>
              </md-select>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 启动参数 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("open_param")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.open_param" />
            </md-field>
          </div>
        </div>
      </div>
      <md-button @click="modal_openModal" class="md-info right-button">{{$I18n("sure")}}</md-button>
    </div>
    <div v-if="msg_plat_type == 2">
      <!-- 平台应用 KEY -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("service_key")}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-50 md-form-item"  @click="clickInput">
            <md-field :class="{'md-error' : error.access_key}">
              <md-input v-model="msg_plat_conf_form.access_key" required disabled />
              <md-icon v-if="error.access_key">clear</md-icon>
            </md-field>
          </div>
          <div class="md-layout md-layout-item md-size-20 md-xsmall-size-100 mx-auto" style="justify-content: flex-end;"> 
            <md-button class="md-info md-round md-fileinput" @click="clickInput">
              {{$I18n("select_file")}}
            </md-button>
          </div>
        </div>
      </div>
      <!-- 本地通知 ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("notif_ch_id")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.notif_ch_id" />
            </md-field>
          </div>
        </div>
      </div>
      <!-- 打开方式 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("open_type")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-select v-model="msg_plat_conf_form.open_type">
                <!-- <md-option :value="0">{{$I18n("none")}}</md-option> -->
                <md-option :value="1">{{$I18n("open_app")}}</md-option>
                <md-option :value="2">{{$I18n("open_activity")}}</md-option>
                <md-option :value="3">{{$I18n("open_url")}}</md-option>
              </md-select>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 启动参数 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("open_param")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.open_param" />
            </md-field>
          </div>
        </div>
      </div>
      <md-button @click="modal_openModal" class="md-info right-button">{{$I18n("sure")}}</md-button>
    </div>
    <div v-if="msg_plat_type == 3">
      <!-- 平台应用ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"APP Key"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.access_id}">
              <md-input v-model="msg_plat_conf_form.access_id" required />
              <md-icon v-if="error.access_id">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 平台应用 KEY -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"Umeng Secret"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.access_key}">
              <md-input v-model="msg_plat_conf_form.access_key" required />
              <md-icon v-if="error.access_key">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 平台应用Secret KEY -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"Master Secret"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.secret_key}">
              <md-input v-model="msg_plat_conf_form.secret_key" required />
              <md-icon v-if="error.secret_key">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 小米渠道ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("xm_ch_id")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.xm_ch_id" />
            </md-field>
          </div>
        </div>
      </div>
      <!-- OPPO ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("oppo_ch_id")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.oppo_ch_id" />
            </md-field>
          </div>
        </div>
      </div>
      <!-- 本地通知 ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("notif_ch_id")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.notif_ch_id" />
            </md-field>
          </div>
        </div>
      </div>
      <!-- 打开方式 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("open_type")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-select v-model="msg_plat_conf_form.open_type">
                <!-- <md-option :value="0">{{$I18n("none")}}</md-option> -->
                <md-option :value="1">{{$I18n("open_app")}}</md-option>
                <md-option :value="2">{{$I18n("open_activity")}}</md-option>
                <md-option :value="3">{{$I18n("open_url")}}</md-option>
              </md-select>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 启动参数 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("open_param")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.open_param" />
            </md-field>
          </div>
        </div>
      </div>
      <md-button @click="modal_openModal" class="md-info right-button">{{$I18n("sure")}}</md-button>
    </div>
    <div v-if="msg_plat_type == 4">
      <!-- 平台应用 KEY -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"APP Key"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.access_key}">
              <md-input v-model="msg_plat_conf_form.access_key" required />
              <md-icon v-if="error.access_key">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 平台应用Secret KEY -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"Master Secret"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.secret_key}">
              <md-input v-model="msg_plat_conf_form.secret_key" required />
              <md-icon v-if="error.secret_key">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 小米渠道ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("xm_ch_id")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.xm_ch_id" />
            </md-field>
          </div>
        </div>
      </div>
      <!-- OPPO ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("oppo_ch_id")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.oppo_ch_id" />
            </md-field>
          </div>
        </div>
      </div>
      <!-- 本地通知 ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("notif_ch_id")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.notif_ch_id" />
            </md-field>
          </div>
        </div>
      </div>
      <!-- 打开方式 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("open_type")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-select v-model="msg_plat_conf_form.open_type">
                <!-- <md-option :value="0">{{$I18n("none")}}</md-option> -->
                <md-option :value="1">{{$I18n("open_app")}}</md-option>
                <md-option :value="2">{{$I18n("open_activity")}}</md-option>
                <md-option :value="3">{{$I18n("open_url")}}</md-option>
              </md-select>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 启动参数 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("open_param")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.open_param" />
            </md-field>
          </div>
        </div>
      </div>
      <md-button @click="modal_openModal" class="md-info right-button">{{$I18n("sure")}}</md-button>
    </div>
    <div v-if="msg_plat_type == 5">
      <!-- 平台应用Secret KEY -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"APP Secret"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.secret_key}">
              <md-input v-model="msg_plat_conf_form.secret_key" required />
              <md-icon v-if="error.secret_key">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 渠道ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("chan_id")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.xm_ch_id" />
            </md-field>
          </div>
        </div>
      </div>
      <!-- 模板ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("notif_template_id")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.notif_template_id" />
            </md-field>
          </div>
        </div>
      </div>
      <!-- 打开方式 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("open_type")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-select v-model="msg_plat_conf_form.open_type">
                <!-- <md-option :value="0">{{$I18n("none")}}</md-option> -->
                <md-option :value="1">{{$I18n("open_app")}}</md-option>
                <md-option :value="2">{{$I18n("open_activity")}}</md-option>
                <md-option :value="3">{{$I18n("open_url")}}</md-option>
              </md-select>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 启动参数 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("open_param")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.open_param" />
            </md-field>
          </div>
        </div>
      </div>
      <md-button @click="modal_openModal" class="md-info right-button">{{$I18n("sure")}}</md-button>
    </div>
    <div v-if="msg_plat_type == 6">
      <!-- 平台应用ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"Client ID"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.access_id}">
              <md-input v-model="msg_plat_conf_form.access_id" required />
              <md-icon v-if="error.access_id">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 平台应用Secret KEY -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"Client Secret"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.secret_key}">
              <md-input v-model="msg_plat_conf_form.secret_key" required />
              <md-icon v-if="error.secret_key">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 打开方式 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("open_type")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-select v-model="msg_plat_conf_form.open_type">
                <!-- <md-option :value="0">{{$I18n("none")}}</md-option> -->
                <md-option :value="1">{{$I18n("open_app")}}</md-option>
                <md-option :value="2">{{$I18n("open_activity")}}</md-option>
                <md-option :value="3">{{$I18n("open_url")}}</md-option>
              </md-select>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 启动参数 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("open_param")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.open_param" />
            </md-field>
          </div>
        </div>
      </div>
      <md-button @click="modal_openModal" class="md-info right-button">{{$I18n("sure")}}</md-button>
    </div>
    <div v-if="msg_plat_type == 7">
      <!-- 文件上传 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("cert_file")}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-50 md-form-item"  @click="clickInput">
            <md-field :class="{'md-error' : error.secret_file}">
              <md-input v-model="msg_form_07.secret_file" required disabled />
              <md-icon v-if="error.secret_file">clear</md-icon>
            </md-field>
          </div>
          <div class="md-layout md-layout-item md-size-20 md-xsmall-size-100 mx-auto"> 
            <md-button class="md-info md-round md-fileinput" @click="clickInput">
              {{$I18n("select_file")}}
            </md-button>
          </div>
        </div>
      </div>
      <div v-if="msg_form_07.file_type" class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("cert_type")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field class="to-div ">
              <md-input v-model="msg_form_07.file_type" disabled style="textTransform: uppercase;"/>
            </md-field>
          </div>
        </div>
      </div>
      <!-- Key ID -->
      <div v-if="msg_form_07.file_type == 'p8'" class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("key_id_02")}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.access_id}">
              <md-input v-model="msg_form_07.access_id" required />
              <md-icon v-if="error.access_id">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- Team ID -->
      <div v-if="msg_form_07.file_type == 'p8'" class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("team_id")}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.access_key}">
              <md-input v-model="msg_form_07.access_key" required />
              <md-icon v-if="error.access_key">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 证书密码 -->
      <div v-if="msg_form_07.file_type == 'p12'" class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("cert_pw")}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.secret_key}">
              <md-input v-model="msg_form_07.secret_key" required type="password"/>
              <md-icon v-if="error.secret_key">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <md-button @click="modal_openModal" class="md-info right-button">{{$I18n("sure")}}</md-button>
    </div>
    <div v-if="msg_plat_type == 8">
      <!-- 平台应用 KEY -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"APP Key"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.access_key}">
              <md-input v-model="msg_plat_conf_form.access_key" required />
              <md-icon v-if="error.access_key">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 平台应用Secret KEY -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"Master Secret"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.secret_key}">
              <md-input v-model="msg_plat_conf_form.secret_key" required />
              <md-icon v-if="error.secret_key">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- OPPO ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("oppo_ch_id")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.oppo_ch_id" />
            </md-field>
          </div>
        </div>
      </div>

      <!-- 打开方式 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("open_type")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-select v-model="msg_plat_conf_form.open_type">
                <!-- <md-option :value="0">{{$I18n("none")}}</md-option> -->
                <md-option :value="1">{{$I18n("open_app")}}</md-option>
                <md-option :value="2">{{$I18n("open_activity")}}</md-option>
                <md-option :value="3">{{$I18n("open_url")}}</md-option>
              </md-select>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 启动参数 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("open_param")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.open_param" />
            </md-field>
          </div>
        </div>
      </div>
      <md-button @click="modal_openModal" class="md-info right-button">{{$I18n("sure")}}</md-button>
    </div>
    <div v-if="msg_plat_type == 9">
      <!-- 平台应用ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"APP ID"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.access_id}">
              <md-input v-model="msg_plat_conf_form.access_id" required />
              <md-icon v-if="error.access_id">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 平台应用 KEY -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"APP Key"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.access_key}">
              <md-input v-model="msg_plat_conf_form.access_key" required />
              <md-icon v-if="error.access_key">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 平台应用Secret KEY -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"App Secret"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.secret_key}">
              <md-input v-model="msg_plat_conf_form.secret_key" required />
              <md-icon v-if="error.secret_key">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 打开方式 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("open_type")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-select v-model="msg_plat_conf_form.open_type">
                <!-- <md-option :value="0">{{$I18n("none")}}</md-option> -->
                <md-option :value="1">{{$I18n("open_app")}}</md-option>
                <md-option :value="2">{{$I18n("open_activity")}}</md-option>
                <md-option :value="3">{{$I18n("open_url")}}</md-option>
              </md-select>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 启动参数 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("open_param")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.open_param" />
            </md-field>
          </div>
        </div>
      </div>
      <md-button @click="modal_openModal" class="md-info right-button">{{$I18n("sure")}}</md-button>
    </div>
    <div v-if="msg_plat_type == 10">
      <!-- 平台应用ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"APP ID"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.access_id}">
              <md-input v-model="msg_plat_conf_form.access_id" required />
              <md-icon v-if="error.access_id">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 平台应用 KEY -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"Client ID"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.access_key}">
              <md-input v-model="msg_plat_conf_form.access_key" required />
              <md-icon v-if="error.access_key">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 平台应用Secret KEY -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"Client Secret"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.secret_key}">
              <md-input v-model="msg_plat_conf_form.secret_key" required />
              <md-icon v-if="error.secret_key">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 打开方式 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("open_type")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-select v-model="msg_plat_conf_form.open_type">
                <!-- <md-option :value="0">{{$I18n("none")}}</md-option> -->
                <md-option :value="1">{{$I18n("open_app")}}</md-option>
                <md-option :value="2">{{$I18n("open_activity")}}</md-option>
                <md-option :value="3">{{$I18n("open_url")}}</md-option>
              </md-select>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 启动参数 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("open_param")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.open_param" />
            </md-field>
          </div>
        </div>
      </div>
      <md-button @click="modal_openModal" class="md-info right-button">{{$I18n("sure")}}</md-button>
    </div>
    <!-- 弹窗 -->
    <modal key="main" v-show="modal" @close="modal_closeModal" class="lg-modal">
      <!-- 弹窗-头部 -->
      <template slot="header">
        <h4 class="modal-title">{{$I18n("tips")}}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modal_closeModal">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <!-- 弹窗-主体 -->
      <template slot="body">
        <div>{{$I18n("is_sure_edit")}}</div>
      </template>
      <!-- 弹窗-底部按钮 -->
      <template slot="footer">
        <md-button @click="modal_submit" class="left-icon md-info">{{$I18n("sure")}}</md-button>
        <md-button @click="modal_closeModal" class="">{{$I18n("cancel")}}</md-button>
      </template>
    </modal>
    <input :ref="'file_input'" style="display: none;" type="file" @change="onFileSelected"/>
  </div>
</template>
<script>

import { Modal } from '@/components';
export default {
  components: {
    Modal,
  },
  props: {
    app_id : {
      type: String,
      default: "",
    },
    client:{
      type: Number,
      default: 0,
    }
  },
  data(){
    return {
      modal: false, // 弹窗是否打开了
      error:{},
      msg_plat_type: 1,
      msg_plat_conf_form: {
        access_id  : "",
        access_key : "",
        secret_key : "",
        xm_ch_id   : "",
        open_type  : 1,
        notif_ch_id: "",
        open_param : "",
        oppo_ch_id : "",
      },
      msg_form_07: {
        file_type  : "",
        secret_file: "",
        access_id  : "",
        access_key : "",
        secret_key : "",
      },
    }
  },
  methods: {
    // 文件上传 (file发生变化)
      onFileSelected ({ target, dataTransfer }) {
        const files = target.files || dataTransfer.files;
        this.getFileName(files, target);
      },
      getFileName(files, target) {
        if (!files || files.length === 0) {
          return target.value.split('\\').pop()
        }
        if (files.length > 1) {
          return // this.getMultipleName(files)
        }
        if(this.msg_plat_type == 7){
          const valid_type = ["p8", "p12"]
          const file_type = files[0].name.split(".").pop().toLocaleLowerCase();
          if(!valid_type.includes(file_type)){
            this.$errorMsg(this.$I18n("pls_uoload_file_02"))
            return
          }
        }
        if (files.length === 1) {
          var formData = new FormData();
          formData.append('myfile', files[0]);
          this.$api.uploadFile(formData)
            .then(this.$Then(res => {
              if(this.msg_plat_type == 7){
                this.msg_form_07.file_type = res.data.split(".").pop().toLocaleLowerCase();
                this.msg_form_07.secret_file = res.data;
              } else {
                this.msg_plat_conf_form.access_key = res.data;
                this.$refs.file_input.value = "";
              }
            }))
            .catch(this.$Catch(this.$I18n("get_error")))
          return files[0].name;
        }
        return null
      },
      clickInput(){ // 图片插件-点击按钮 触发 img input
        this.$refs.file_input.click();
      },
    // 文件上传 - END
    modal_openModal (){ // 弹窗-打开弹窗
      this.error = {
        access_id :   !this.msg_plat_type == 4 && !this.msg_plat_conf_form.access_id ,
        access_key  : !this.msg_plat_conf_form.access_key ,
        secret_key  : !this.msg_plat_type == 2 && !this.msg_plat_conf_form.secret_key ,
      }
      if(this.msg_plat_type == 1 || this.msg_plat_type == 3){
        this.error = {
          access_id :   !this.msg_plat_conf_form.access_id ,
          access_key  : !this.msg_plat_conf_form.access_key ,
          secret_key  : !this.msg_plat_conf_form.secret_key ,
        }
      }
      if(this.msg_plat_type == 4){
        this.error = {
          access_key : !this.msg_plat_conf_form.access_key ,
          secret_key : !this.msg_plat_conf_form.secret_key ,
        }
      }
      // 小米
      if(this.msg_plat_type == 5){
        this.error = {
          secret_key: !this.msg_plat_conf_form.secret_key,
        }
      }
      // 华为
      if(this.msg_plat_type == 6){
        this.error = {
          access_id : !this.msg_plat_conf_form.access_id,
          secret_key: !this.msg_plat_conf_form.secret_key,
        }
      }
      // APNS
      if(this.msg_plat_type == 7){
        if(this.msg_form_07.file_type === "p8"){
          this.error = {
            access_id: !this.msg_form_07.access_id,
            access_key: !this.msg_form_07.access_key,
          }
        } else if(this.msg_form_07.file_type === "p12"){
          this.error = {
            secret_key: !this.msg_form_07.secret_key,
          }
        } else {
          this.error = {
            file_type: true,
          }
        }
      }
      // OPPO
      if(this.msg_plat_type == 8){
        this.error = {
          access_key: !this.msg_plat_conf_form.access_key,
          secret_key: !this.msg_plat_conf_form.secret_key,
        }
      }
      // VIVO
      if(this.msg_plat_type == 9){
        this.error = {
          access_id : !this.msg_plat_conf_form.access_id,
          access_key : !this.msg_plat_conf_form.access_key,
          secret_key : !this.msg_plat_conf_form.secret_key,
        }
      }
      // Honor
      if(this.msg_plat_type == 10){
        this.error = {
          access_id : !this.msg_plat_conf_form.access_id,
          access_key : !this.msg_plat_conf_form.access_key,
          secret_key : !this.msg_plat_conf_form.secret_key,
        }
      }
      for(var key in this.error){
        if(this.error[key]){
          this.$errorMsg(this.$I18n("pls_check_verify"))
          return 
        }
      }
      this.modal = true;
    },
    modal_closeModal(){ // 弹窗-关闭弹窗
      this.modal = false;
    },
    api_getMsgPlatInit(){
      this.msg_plat_conf_form = {
        access_id   : "",
        access_key  : "",
        secret_key  : "",
        xm_ch_id    : "",
        open_type   : 1,
        open_param  : "",
        oppo_ch_id  : "",
        notif_ch_id : "",
      }
      this.msg_form_07 = {
        file_type  : "",
        secret_file: "",
        access_id  : "",
        access_key : "",
        secret_key : "",
      }
      return this.$api.getMsgPlatform({
        app_id : this.app_id,
        type : this.msg_plat_type,
      })
        .then(this.$Then(res => {
          if(res.data && res.data.length > 0 && res.data[0].id){
            this.msg_plat_conf_form = {
              ...res.data[0],
              open_type : res.data[0].open_type ?res.data[0].open_type :1,
            }
            if(this.msg_plat_type == 2){
              this.msg_plat_conf_form.access_key = res.data[0].secret_file;
            }
            if(this.msg_plat_type == 7){
              const fileType = res.data[0].secret_file
                ?res.data[0].secret_file.split(".").pop().toLocaleLowerCase()
                :""
              this.msg_form_07 = {
                ...res.data[0],
                file_type: fileType,
              }
            }
          }
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    modal_submit(){ // 弹窗-提交修改
      let sendData = {
        ...this.msg_plat_conf_form,
        secret_file: this.msg_plat_type == 2 ?this.msg_plat_conf_form.access_key: "",
        access_key : this.msg_plat_type != 2 ?this.msg_plat_conf_form.access_key: "",
        type : this.msg_plat_type,
        app_id: this.app_id,
      }
      if(this.msg_plat_type == 5){
        sendData = {
          secret_key : this.msg_plat_conf_form.secret_key,
          xm_ch_id   : this.msg_plat_conf_form.xm_ch_id,
          open_type  : this.msg_plat_conf_form.open_type,
          open_param : this.msg_plat_conf_form.open_param,
          notif_template_id : this.msg_plat_conf_form.notif_template_id,
          type : this.msg_plat_type,
          app_id: this.app_id,
        }
      }
      if(this.msg_plat_type == 6){
        sendData = {
          access_id  : this.msg_plat_conf_form.access_id,
          secret_key : this.msg_plat_conf_form.secret_key,
          open_type  : this.msg_plat_conf_form.open_type,
          open_param : this.msg_plat_conf_form.open_param,
          type : this.msg_plat_type,
          app_id: this.app_id,
        }
      }
      if(this.msg_plat_type == 7){
        sendData = {
          ...this.msg_form_07,
          type : this.msg_plat_type,
          app_id: this.app_id,
        }
      }
      return this.$api.editMsgPlatform(sendData)
        .then(this.$Then(() => {
          this.modal = false;
          this.api_getMsgPlatInit();
          this.$successMsg(this.$I18n("edit_success"));
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
  },
  watch:{
    msg_plat_type(){
      this.api_getMsgPlatInit();
      this.error = {};
    },
  },
  created(){
    this.api_getMsgPlatInit();
  },
}
</script>
<style scoped>
  div{
    transition: none !important;
  }
  .to-div {
    justify-content: flex-end;
    cursor: default;
    border-bottom: none !important;
  }
  .to-div /deep/ input{
    cursor: default !important;
  }
  .to-div:after{
    border-bottom: none !important;
  }
</style>